//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const RbLoading = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loading/rb-loading.vue')

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import RbDynamicSwiperSlide from '../../../smart-container/dynamic-swiper-slide'
import DynamicGridStellaProduct from './dynamic-grid-stella-product'
export default {
  name: 'rb-combo-of-boards-with-all-fields-below',
  components: {
    RbDynamicSwiperSlide,
    DynamicGridStellaProduct,
    RbLoading,
  },
  data() {
    return {
      defaultConfig: {
        spaceBetween: 8,
        slidesPerView: '1',
      },
    }
  },
  computed: {
    showSwiper() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    swiperSlides() {
      return this.$slots.default.filter((slot) => !!slot.tag)
    },
    totalOfSlides() {
      return this.swiperSlides.length
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.reInitSwiper()
    })
  },
  methods: {
    reInitSwiper() {
      if (this.$refs.swiperRef?.swiper) {
        this.$refs.swiperRef.swiper.destroy()
        this.$nextTick(() => {
          this.$refs.swiperRef.$options.propsData.config.allowTouchMove = true
          this.$refs.swiperRef._setup()
        })
      }
    },
  },
}
